import { render, staticRenderFns } from "./Gesture.vue?vue&type=template&id=22d2588d&"
import script from "./Gesture.vue?vue&type=script&lang=js&"
export * from "./Gesture.vue?vue&type=script&lang=js&"
import style0 from "./Gesture.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports